<div class="row" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>

<div class="container row mt-3 mb-5">
  <div class="col-8">
    <mat-card class="p-3">
      <h5>Come funziona il versioning</h5>
      <p>
        Il grafico rappresenta la cronologia delle versioni di una survey. Ogni box rappresenta una versione e ne mostra lo stato e il numero di versione.
      </p>
      <p>
        Il sistema di versioning segue la convenzione <code>vX.Y</code> dove:
      </p>
      <ul>
        <li>
          La <strong>major version</strong> (<code>X</code>) aumenta quando viene modificata la struttura della survey, ad esempio aggiungendo, modificando o eliminando domande. Viene così creata una nuova survey a partire da quella precedente (es: da <code>v1.0</code> a <code>v2.0</code>).
        </li>
        <li>
          La <strong>minor version</strong> (<code>Y</code>) aumenta quando la survey viene semplicemente riutilizzata per una nuova sessione, senza modificarne le domande (es: da <code>v1.0</code> a <code>v1.1</code>).
        </li>
      </ul>
      <p>
        Questo sistema consente di mantenere una tracciabilità completa delle evoluzioni della survey nel tempo.
      </p>
    </mat-card>
  </div>

  <div class="col-3">
    <mat-card class="p-3">
      <h6>{{ "generic.legend" | translate }}</h6>
      <div class="legend-item d-flex align-items-center mb-2">
        <div class="legend-color me-2" style="width: 16px; height: 16px; background-color: #1F9E99;"></div>
        <span>{{ "generic.current-survey" | translate }}</span>
      </div>
      <div class="legend-item d-flex align-items-center mb-2">
        <div class="legend-color me-2" style="width: 16px; height: 16px; background-color: #5C39A1;"></div>
        <span>{{ "generic.started-survey" | translate }}</span>
      </div>
      <div class="legend-item d-flex align-items-center">
        <div class="legend-color me-2" style="width: 16px; height: 16px; background-color: #e0e0e0; border: 1px solid #ccc;"></div>
        <span>{{ "generic.draft-survey" | translate }}</span>
      </div>
    </mat-card>
  </div>
</div>


<div class="mermaid-container w-100">
  <div #mermaid></div>
</div>


<div class="container">
  <app-all-surveys
    *ngIf="survey_history"
    [groupedByHistory]="false"
    [filterable]="false"
    [input_surveys]="survey_history?.surveys"
    [inputColumns]="['title', 'created_at', 'created_by_user', 'version_number']"
    [addable]="false"
    [outerTableRowIsNavigable]="true"
  />
</div>
